import { PasswordRule } from './PasswordRule';

class MinCharacterCount extends PasswordRule {

    name = 'MinCharacterCount';
    errorMessage = 'min_character_count_not_met';
    charCount = 0;
    charSet = '';

    constructor(charCount, charSet) {
        super();
        this.charCount = charCount;
        this.charSet = charSet;
    }

    passes(input) {
        let count = 0;

        for (const char of input) {
            if (this.charSet.includes(char)) {
                count++;
            }
        }
        return count >= this.charCount;
    }


    getAttributes() {
        return {
            minimumCount: this.charCount
        };
    }
}

export class UppercaseCount extends MinCharacterCount {
    name = 'UppercaseCount';
    errorMessage = 'uppercase_character_count_not_met';

    constructor(charCount) {
        super(charCount, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ');
    }
}

export class LowercaseCount extends MinCharacterCount {
    name = 'LowercaseCount';
    errorMessage = 'lowercase_character_count_not_met';

    constructor(charCount) {
        super(charCount, 'abcdefghijklmnopqrstuvwxyz');
    }
}

export class SpecialCharactersCount extends MinCharacterCount {
    name = 'SpecialCharactersCount';
    errorMessage = 'special_character_count_not_met';

    constructor(charCount) {
        super(charCount, '!@#$%^&*()-_=+[]{}|;:\'",.<>?/`~');
    }
}

export class DigitsCount extends MinCharacterCount {
    name = 'DigitsCount';
    errorMessage = 'digit_character_count_not_met';

    constructor(charCount) {
        super(charCount, '0123456789');
    }
}
